export default __webpack_public_path__ + "static/media/karen_main.e38f0856.jpg";